<template>
  <SCADropdown
    :placement="isMini ? 'right-start' : 'bottom-end'"
    :offset-y="isMini ? 8 : 4"
    :offset-x="isMini ? -9 : 0"
    no-padding
    :trigger="isMini ? 'hover' : 'click'"
    shadow-variant="upward"
    no-mobile-margin
  >
    <template #trigger="{ target }">
      <SCAIconButton
        size="xsmall"
        :type="isMini ? 'ghost' : 'default'"
        appearance="secondary"
        icon="phosphor/more-horizontal"
        :title="$t('common.label.navbarSettings')"
        :popovertarget="target"
        @click.stop
      />
    </template>
    <template #default="{ popover }">
      <div :class="$style.content">
        <SCADropdownItem
          type="action"
          :label="$t('common.action.collapse')"
          :disabled="searchActive || allCollapsed"
          appearance="secondary"
          use-small-padding
          @click.stop="
            if (!searchActive) {
              setAllExpanded(false);
              popover?.hidePopover();
            }
          "
        />
        <SCADropdownItem
          type="action"
          :label="$t('common.action.expand')"
          :disabled="searchActive || allExpanded"
          appearance="secondary"
          use-small-padding
          @click.stop="
            if (!searchActive) {
              setAllExpanded(true);
              popover?.hidePopover();
            }
          "
        />

        <SCADivider :class="$style.divider" appearance="border"></SCADivider>

        <SCADropdownItem
          type="action"
          :label="$t('common.action.showNavigation')"
          appearance="secondary"
          :selected="layoutStore.sidebarNavContent === 'navigation'"
          use-small-padding
          @click.stop="
            layoutStore.setSidebarNavContent('navigation');
            popover?.hidePopover();
          "
        />
        <SCADropdownItem
          type="action"
          :label="$t('common.action.showFavourites')"
          appearance="secondary"
          :selected="layoutStore.sidebarNavContent === 'favorites'"
          use-small-padding
          @click.stop="
            layoutStore.setSidebarNavContent('favorites');
            popover?.hidePopover();
          "
        />

        <SCADivider :class="$style.divider" appearance="border"></SCADivider>

        <SCADropdownItem
          type="radio"
          :label="$t('common.label.defaultNavbar')"
          appearance="secondary"
          @click.stop="
            layoutStore.sidebarNavMode === 'default'
              ? undefined
              : (popover?.hidePopover(), layoutStore.setSidebarNavMode('default'))
          "
        >
          <input type="radio" :checked="layoutStore.sidebarNavMode === 'default'" />
        </SCADropdownItem>
        <SCADropdownItem
          type="radio"
          :label="$t('common.label.miniNavbar')"
          appearance="secondary"
          :checked="layoutStore.sidebarNavMode === 'mini'"
          @click.stop="
            layoutStore.sidebarNavMode === 'mini'
              ? undefined
              : (popover?.hidePopover(), layoutStore.setSidebarNavMode('mini'))
          "
        >
          <input type="radio" :checked="layoutStore.sidebarNavMode === 'mini'" />
        </SCADropdownItem>
      </div>
    </template>
  </SCADropdown>
</template>

<script setup lang="ts">
import { SCADivider, SCADropdown, SCADropdownItem, SCAIconButton } from "@scayla/components";

import { useLayoutStore } from "@/store/layoutStore";

withDefaults(
  defineProps<{
    searchActive?: boolean;
    isMini?: boolean;
    setAllExpanded?: (expanded: boolean) => void;
    allExpanded?: boolean;
    allCollapsed?: boolean;
  }>(),
  {
    searchActive: false,
    isMini: false,
    setAllExpanded: undefined,
    allExpanded: false,
    allCollapsed: false,
  },
);

const layoutStore = useLayoutStore();
</script>

<style lang="scss" module>
.content {
  display: flex;
  flex-direction: column;
  gap: var(--space-component-gap-xSmall);
  width: 232px;
}
.divider {
  margin: var(--space-component-padding-xSmall) calc(var(--space-component-padding-small) * (-1));
}
</style>
